define('responsive-pitch-fx/lib/helpers/Scaler',['require','exports','module','../math/gcd','../enums/config'],function(require,exports,module){
    var gcd = require( '../math/gcd' );

    function Scaler(w){
    	w=w||this.base_width;
    	var h=w/this.base_width*this.base_height;
        // h=mindims = w/gcd(this.scalers.base_width, this.scalers.base_height)*this.scalers.base_width;
        var relativeXScale = (this.interpolatedPlateWidth / this.base_width) / (17 / this.foot),
            relativeYScale = (this.interpolatedPlateFront / this.base_height) / (17 / this.foot),
            x = relativeXScale * w,
            y = relativeYScale * h;
        
            /*  Original value matrix :
             Android -  ppf ~= 51 @ 620px
             iPad  -    ppf  = 75 @ 1024px
             */
            this.minHeight = h/w*100;
            this.relativeXScale= relativeXScale;
            this.relativeYScale = relativeYScale;
            this.homePlateWidth = 17 / this.foot;
            this.homePlateFrontY = 17 / this.foot;
            this.homePlateBackY = 17 / this.foot * 2;
            this.fakeBallSize = (2.94 / this.foot / 1.8) * y;
            // View Restrictions
            this.YOffsetViewBottomMargin = 0,//interpolatedPlateWidth/704*h,//40.0;
            // 3D Camera Simulation
            // Need to move things down in the view
            this.YOffset = (200 / this.base_height) * h,//60.0 * y;
            //var kEyetoScreen = 10.0; // Wide angle, eye closer to the screen
            this.eyetoScreenY = (this.eyeToScreen / this.base_height) * h,//Math.pow((Math.pow(consts.eyetoScreen,2) / Math.pow(consts.base_height,2)) * Math.pow(h,2),0.5); // was 10
            this.eyetoScreenX = (this.eyeToScreen / this.base_width) * w; // was 10
            // 2D pitch from device gameday...
            this.x = x;
            this.y = y;
            this.width = w;
            this.height = h;
            this.offset_x = this.offset_x / this.base_width * w;
            this.offset_y = this.offset_y / this.base_height * h;

            this.maxlinewidth = (2.94 / this.foot / 1.8) * y,//18/1024*w;
            this.viewBottomMargin = 184 / this.base_height * h;
            // this.batterScale = 5.917 * relativeYScale;
            this.batterX = this.batterX / (this.base_width * w) * w * 100;
            this.batterY = this.batterY / (this.base_height * h) * h * 100;
            this.batterTop = this.batterTop / (this.base_height * h) * h * 100;
            this.batterLR = this.batterLR / (this.base_width * w) * w * 100;
            // this.batterRight = consts.batterRight/(consts.base_width*w)*w*100;
            this.szBorder = 6 / this.base_width * w;
            this.szPadding= 50 / this.base_width * w
    }

    Scaler.prototype =  require( '../enums/config' );
    return Scaler;
});

